import CurrentOrganization from './CurrentOrganization'

export default CurrentOrganization



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/CurrentOrganization/index.js